import { useState } from "react";

import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect";
import useEventListener from "./useEventListener";

export const TABLET_WIDTH = 768;
export const DESKTOP_WIDTH = 1024;
export const WIDESCRREN_WIDTH = 1216;
export const FULLHD_WIDTH = 1408;
export const ULTRAHD_WIDTH = 1920;

interface WindowSize {
  width: number;
  height: number;
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  });

  const handleSize = () => {
    if (typeof window !== "undefined") {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
  };

  //Define empty fallback function if window is undefined
  const noop = () => {};
  useEventListener("resize", typeof window !== "undefined" ? handleSize : noop);

  // Set size at the first client-side load
  useIsomorphicLayoutEffect(() => {
    if (typeof window !== "undefined") {
      handleSize();
    }
  }, []);

  return windowSize;
}

export default useWindowSize;
